if (!customElements.get('product-offer-selector')) {
  customElements.define(
    'product-offer-selector',
    class ProductOfferSelector extends HTMLElement {
      connectedCallback() {
        this.#formId = this.dataset.formId;
        this.#basicVariantId = this.dataset.basicVariantId;
        this.#packVariantId = this.dataset.packVariantId;
        this.#options = this.querySelectorAll('.product-offer-selector__option');
        this.#inputs = this.querySelectorAll('.product-offer-selector__input');

        for (const input of this.#inputs) {
          input.addEventListener('change', () => this.#onSelectionChange(input));
        }

        const checkedInput = this.querySelector('.product-offer-selector__input:checked');
        if (checkedInput) this.#onSelectionChange(checkedInput);
      }

      #formId;
      #basicVariantId;
      #packVariantId;
      #options;
      #inputs;

      #onSelectionChange(input) {
        if (!input.checked) return;

        const isPack = input.value === 'pack';
        const variantId = isPack ? this.#packVariantId : this.#basicVariantId;

        for (const option of this.#options) {
          const optionInput = option.querySelector('.product-offer-selector__input');
          const isSelected = optionInput === input;
          option.classList.toggle('product-offer-selector__option--selected', isSelected);
        }

        this.#updateVariantInputs(variantId);
        this.#updateOfferVisibility(isPack);

        this.dispatchEvent(
          new CustomEvent('product-offer-selector:change', {
            bubbles: true,
            detail: {
              option: input.value,
              variantId,
              isPack,
            },
          })
        );
      }

      #updateVariantInputs(variantId) {
        if (!variantId) return;

        const form = document.getElementById(this.#formId);
        const idInput = form?.querySelector('[name="id"]');
        if (idInput) {
          idInput.value = variantId;
          idInput.disabled = false;
        }

        const installmentInput = document.querySelector('#mainSelectedProduct');
        if (installmentInput) installmentInput.value = variantId;
      }

      #updateOfferVisibility(isPack) {
        for (const element of document.querySelectorAll('.offre-basique')) {
          element.style.display = isPack ? 'none' : 'grid';
        }

        for (const element of document.querySelectorAll('.offre-pack')) {
          element.style.display = isPack ? 'grid' : 'none';
        }
      }
    }
  );
}
